<template>
  <div>
    <div class="flex items-center text-black-victor font-bold text-base select-none pb-1">
      <span v-if="useLocalTitle">Audio Fade</span>
      <div class="flex pl-3">
        <div class="form-check form-switch flex items-center">
          <Toggle
            v-model="syncWithVideo"
            :classes="{
              toggle: 'flex w-6 h-3 rounded-full relative cursor-pointer transition items-center box-content border-2 text-xs leading-none',
              handle: 'inline-block bg-white w-3 h-3 top-0 rounded-full absolute transition-all',
              toggleOn: 'bg-blue-450 border-blue-450 justify-start text-white',
              toggleOff: 'bg-gray-200 border-gray-200 justify-end text-gray-700',
            }"
            class="focus:ring-0"
            @change="onSyncChange"
          />
          <label
            :class="[syncWithVideo ? 'opacity-100' : 'opacity-50']"
            class="pl-1 form-check-label inline-block text-black-victor text-xs font-semibold"
          >
            Sync with video
          </label>
        </div>
      </div>
    </div>

    <AfadeInOutComponent
      :key="aFadeInModel"
      v-model:aFadeInOutModel="aFadeInModel"
      :active="aFadeInModel.active"
      label="Fade In"
    />

    <AfadeInOutComponent
      :key="aFadeOutModel"
      v-model:aFadeInOutModel="aFadeOutModel"
      :active="aFadeOutModel.active"
      class="mt-4"
      label="Fade Out"
    />
  </div>
</template>

<script>
import Toggle from '@vueform/toggle'
import AfadeInOutComponent from "../AfadeInOutComponent"

export default {
  name: 'AudioFadeTab',
  components: {
    AfadeInOutComponent,
    Toggle
  },
  props: {
    useLocalTitle: {
      type: Boolean,
      default: true
    },
    ffmpegData: {
      type: Object,
      required: true
    },
    isFadeSyncWithVideo: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  emits: ['update:isFadeSyncWithVideo', 'sync-change', 'update:ffmpegData'],
  computed: {
    syncWithVideo: {
      get () {
        return this.isFadeSyncWithVideo
      },
      set (val) {
        this.$emit('update:isFadeSyncWithVideo', val)
      }
    },
    aFadeInModel: {
      get () {
        return this.ffmpegData.a_fade_in_model
      },
      set (val) {
        this.$emit('update:ffmpegData', {
          ...this.ffmpegData,
          a_fade_in_model: val
        })
      }
    },
    aFadeOutModel: {
      get () {
        return this.ffmpegData.a_fade_out_model
      },
      set (val) {
        this.$emit('update:ffmpegData', {
          ...this.ffmpegData,
          a_fade_out_model: val
        })
      }
    }
  },
  methods: {
    onSyncChange (val) {
      this.$emit('sync-change', val)
    }
  }
}
</script>

<style scoped>
</style>
